import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { ArrowRight, ArrowLeft } from "@phosphor-icons/react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const initialToken = params.get("token") || "";
  const [token, setToken] = useState(initialToken);
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setMsg("");
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      setMsg("Password updated! Redirecting to login…");
      setTimeout(() => nav("/login"), 1500);
    } catch (e) {
      setMsg(e.response?.data?.detail || "Reset failed.");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-ink flex items-center justify-center px-5 py-10 grain">
      <div className="relative z-10 w-full max-w-md crystal-glass rounded-3xl p-8 sm:p-10 animate-fade-up">
        <Link to="/login" className="inline-flex items-center gap-2 text-cream/60 hover:text-cream text-xs tracking-[0.2em] uppercase font-bold mb-4">
          <ArrowLeft size={14} /> Back to login
        </Link>
        <p className="text-papaya text-xs tracking-[0.3em] uppercase font-bold">Reset</p>
        <h1 className="text-cream text-4xl font-black tracking-tighter mt-1 leading-none">Set a new<br/>password.</h1>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <label className="block">
            <span className="text-cream/70 text-xs tracking-[0.2em] uppercase font-bold">Token</span>
            <input
              data-testid="reset-token"
              required
              value={token}
              onChange={(e) => setToken(e.target.value)}
              className="mt-2 w-full bg-white/5 border border-white/10 rounded-2xl px-4 py-3 text-cream focus:outline-none focus:border-papaya text-xs"
            />
          </label>
          <label className="block">
            <span className="text-cream/70 text-xs tracking-[0.2em] uppercase font-bold">New Password (min 6)</span>
            <input
              data-testid="reset-password"
              type="password"
              required
              minLength={6}
              value={pw}
              onChange={(e) => setPw(e.target.value)}
              className="mt-2 w-full bg-white/5 border border-white/10 rounded-2xl px-4 py-3 text-cream focus:outline-none focus:border-papaya"
            />
          </label>
          <button
            data-testid="reset-submit"
            type="submit"
            disabled={busy}
            className="w-full py-4 rounded-full bg-papaya text-ink font-black tracking-[0.2em] uppercase text-sm hover:bg-papaya-hover transition-colors flex items-center justify-center gap-2 disabled:opacity-50"
          >
            {busy ? "Updating…" : <>Update password <ArrowRight size={16} weight="bold" /></>}
          </button>
        </form>
        {msg && <p data-testid="reset-msg" className="mt-5 text-sm text-cream/80">{msg}</p>}
      </div>
    </div>
  );
}
